import { ArrowRight, Sparkles } from "lucide-react";

const CLIENTS = [
  { name: "KM Builders", style: "italic" },
  { name: "Ora Makers", style: "tracking-[0.4em] uppercase" },
  { name: "Zenith House", style: "font-display" },
  { name: "KM Builders", style: "italic" },
  { name: "Ora Makers", style: "tracking-[0.4em] uppercase" },
  { name: "Zenith House", style: "font-display" },
];

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen pt-40 pb-12 overflow-hidden hero-gradient"
    >
      <div aria-hidden className="absolute inset-0 -z-10 grid-pattern-light opacity-50" />
      <div
        aria-hidden
        className="absolute -z-10 left-1/2 top-1/3 -translate-x-1/2 -translate-y-1/2 w-[1100px] h-[1100px] rounded-full"
        style={{
          background:
            "radial-gradient(closest-side, rgba(39,112,253,0.05), transparent 70%)",
          filter: "blur(20px)",
        }}
      />
      <div aria-hidden className="absolute inset-x-0 bottom-0 -z-10 h-40 bg-gradient-to-b from-transparent to-white" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center">
        {/* Tagline pill */}
        <div
          data-testid="hero-tagline"
          className="reveal inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#2770FD]/25 bg-[#2770FD]/5 text-xs uppercase tracking-[0.25em] text-[#2770FD]"
        >
          <Sparkles className="h-3.5 w-3.5 text-[#2770FD]" />
          Results that Resonate
        </div>

        {/* Headline — same font + size for both; only the accent gets the
            royal-blue gradient + shimmer treatment. */}
        <h1
          data-testid="hero-headline"
          className="reveal font-display mt-8 max-w-6xl text-center text-5xl sm:text-7xl lg:text-8xl leading-[1.05]"
          style={{ animationDelay: "0.05s" }}
        >
          <span
            data-testid="hero-headline-line1"
            className="text-black"
            style={{ marginRight: "12px" }}
          >
            We Engineer
          </span>
          <span
            data-testid="hero-headline-accent"
            className="xfactor-shimmer-text"
          >
            The X-Factor
          </span>
        </h1>

        {/* Sub-headline */}
        <p
          data-testid="hero-subheadline"
          className="reveal mt-8 max-w-3xl text-base sm:text-lg text-black/70 font-light leading-relaxed"
          style={{ animationDelay: "0.15s" }}
        >
          Dynamic X Media breaks the artificial divide between high-concept
          storytelling and cold performance metrics. We combine data-driven
          performance campaigns, brand identity, and premium print media to
          build powerful{" "}
          <span className="text-black font-semibold">360° ecosystems</span>.
        </p>

        {/* CTA */}
        <div
          className="reveal mt-12 flex flex-col sm:flex-row items-center gap-4"
          style={{ animationDelay: "0.25s" }}
        >
          <a
            href="https://calendly.com/dynamicxmedia-in/30min"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-button"
            className="group inline-flex items-center gap-2 px-7 py-4 rounded-full bg-cta-solid text-white text-base font-semibold glow-cta-light transition-all duration-300 hover:-translate-y-1"
          >
            Book a Free Strategy Call
            <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </a>
          <a
            href="#services"
            data-testid="hero-secondary-cta"
            className="inline-flex items-center gap-2 px-6 py-4 rounded-full border border-black/15 text-black text-sm font-medium hover:bg-black/5 hover:border-[#2770FD]/40 transition"
          >
            Explore our services
          </a>
        </div>

        {/* Client marquee */}
        <div
          data-testid="client-marquee"
          className="mt-24 w-full border-y border-black/10 py-10"
        >
          <p className="text-xs uppercase tracking-[0.3em] text-black/50 text-center mb-8">
            Trusted by Leading Real Estate &amp; Modern Brands
          </p>
          <div className="relative overflow-hidden">
            <div className="marquee-track flex w-max gap-20 items-center">
              {[...CLIENTS, ...CLIENTS].map((c, i) => (
                <span
                  key={`${c.name}-${i}`}
                  data-testid={`client-logo-${i}`}
                  className={`text-2xl sm:text-3xl text-black/40 hover:text-[#2770FD] transition-colors duration-300 whitespace-nowrap ${c.style}`}
                >
                  {c.name}
                </span>
              ))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-white to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
